export default __webpack_public_path__ + "static/supercoach-475fb6b37a0f1af023d0870f89a0ffa7.png";